var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbiden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96",
    id: "forbidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 38.5,
    stroke: "#12182B",
    strokeWidth: 5,
    transform: "rotate(-45 47.5 47.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#12182B",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M21.337 74.3691L73.6629 22.0432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbiden);
export default __webpack_public_path__ + "static/media/forbiden.28ad308c841315c0da6fd70b4edc3768.svg";
export { ForwardRef as ReactComponent };